import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { UNORDERED_VERTICAL_LIST_BASE_CLASSNAME } from './Constants';
import { createUnorderedVerticalList } from './UnorderedVerticalList';
createComponents(".".concat(UNORDERED_VERTICAL_LIST_BASE_CLASSNAME), createUnorderedVerticalList, NO_PATTERN_BUSINESS_LOGIC);
